
var Model = require("../types/Model.js");
var window = require("global");
var prop = require("prop");
var par = require("par");

var getSettingsPlugin = par(prop("plugins.aetonixsetting"), window);

var timeout = 30 * 1000;
var PASSWORD = "aetonix456";

module.exports = new Model({
	name: "about",

	_timer: null,

	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	clear_timer: clear_timer,
	start_timer: start_timer,
	hide_box: hide_box
});

function init() {
	this.push({
		open: false,
		updateState: "none",
		showPassword: false,
		showSettings: !!getSettingsPlugin(),
		passwordError: false,
	});
}

function uninit() {
	this.clear_timer();
}

function listeners() {
	return {
		"atouchawaysettings:updated": handle_settings_updated,
		"contentupdate:updated": handle_content_update_updated,
		"license:updated": handle_license_update,
		"privacypolicy:updated": handle_privacy_policy_update
	};
}

function triggers() {
	return {
		"open": show_box,
		"close": hide_box,
		"exit": exit_setting,
		"settings:android": handle_trigger_setting_android,
		"settings": handle_trigger_setting,
		"unlock": handle_trigger_unlock,
	};
}

function show_box() {
	this.start_timer();
	this.extend({
		open: true
	});
	this.emit("usermetrics:trigger:track", "show atouchaway about box");
}

function hide_box() {
	this.clear_timer();
	this.extend({
		open: false,
		passwordError: false,
	});
	this.emit("usermetrics:trigger:track", "hide atouchaway about box");
}

function start_timer() {
	this._timer = setTimeout(hide_box.bind(this), timeout);
}

function clear_timer() {
	if (!this._timer) return;
	clearTimeout(this._timer);
	this._timer = undefined;
}

function handle_trigger_setting_android() {
	var plugin = getSettingsPlugin();
	if(!plugin) {
		this.emit("usermetrics:trigger:track", "attempt to open atouchaway admin android settings but not on an android device");
		return;
	}
	plugin.openSetting("settings", noop, noop);
}

function handle_trigger_setting() {
	this.extend({
		open: false,
	});

	this.dispatch("settings");

	this.emit("usermetrics:trigger:track", "open atouchaway aboutbox settings");
}

function handle_settings_updated(settings) {
	var locked = settings.locked;

	var showPassword = !!locked;

	this.extend({
		showPassword: showPassword
	});
}

function handle_content_update_updated(update) {
	var state = update.updateState;

	this.extend({
		updateState: state
	});
}

function handle_trigger_unlock(data) {
	var password = data.password;

	if(password === PASSWORD){
		this.emit("usermetrics:trigger:track", "unlock and open atouchaway admin settings");
		this.dispatch("unlocked");
		this.extend({
			passwordError: false,
			open: false,
		});
	}else{
		this.emit("usermetrics:trigger:track", "enter incorrect password while trying to unlock atouchaway admin settings");
		this.extend({
			passwordError: true
		});
	}
}

function exit_setting() {
	this.extend({
		open: false,
		passwordError: false
	});
	this.dispatch("exit");

	this.emit("usermetrics:trigger:track", "close atouchaway admin settings");
}

function noop() {}

function handle_license_update(data){
	if(data) this.hide_box();
}

function handle_privacy_policy_update(data){
	if(data) this.hide_box();
}